import * as React from 'react';
import type { SVGProps } from 'react';
const ArrowSquareOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M228 104C228 107.183 226.736 110.235 224.485 112.485C222.235 114.736 219.183 116 216 116C212.817 116 209.765 114.736 207.515 112.485C205.264 110.235 204 107.183 204 104V69L144.49 128.51C142.236 130.764 139.178 132.031 135.99 132.031C132.802 132.031 129.744 130.764 127.49 128.51C125.236 126.256 123.969 123.198 123.969 120.01C123.969 116.822 125.236 113.764 127.49 111.51L187 52H152C148.817 52 145.765 50.7357 143.515 48.4853C141.264 46.2348 140 43.1826 140 40C140 36.8174 141.264 33.7652 143.515 31.5147C145.765 29.2643 148.817 28 152 28H216C219.183 28 222.235 29.2643 224.485 31.5147C226.736 33.7652 228 36.8174 228 40V104ZM184 128C180.817 128 177.765 129.264 175.515 131.515C173.264 133.765 172 136.817 172 140V204H52V84H116C119.183 84 122.235 82.7357 124.485 80.4853C126.736 78.2348 128 75.1826 128 72C128 68.8174 126.736 65.7652 124.485 63.5147C122.235 61.2643 119.183 60 116 60H48C42.6957 60 37.6086 62.1071 33.8579 65.8579C30.1071 69.6086 28 74.6957 28 80V208C28 213.304 30.1071 218.391 33.8579 222.142C37.6086 225.893 42.6957 228 48 228H176C181.304 228 186.391 225.893 190.142 222.142C193.893 218.391 196 213.304 196 208V140C196 136.817 194.736 133.765 192.485 131.515C190.235 129.264 187.183 128 184 128Z"
      fill="currentColor"
    />
  </svg>
);
export default ArrowSquareOut;
